import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DienstleistungsArt } from '../../domain/model/dienstleistungsart.model';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class DienstleistungsartService {

    private http = inject(HttpClient);

    public listDienstleistungsarten(): Observable<DienstleistungsArt[]> {
        return this.http.get<DienstleistungsArt[]>(environment.API_URL + '/dienstleistungsart');
    }

    public getDienstleistungsart(id: number): Observable<DienstleistungsArt> {
        return this.http.get<DienstleistungsArt>(environment.API_URL + '/dienstleistungsart/' + id);
    }

    public createDienstleistungsart(dl: DienstleistungsArt): Observable<DienstleistungsArt> {
        return this.http.post<DienstleistungsArt>(environment.API_URL + '/admin/dienstleistungsart/', dl);
    }

    public updateDienstleistungsart(dl: DienstleistungsArt): Observable<DienstleistungsArt> {
        return this.http.put<DienstleistungsArt>(environment.API_URL + '/admin/dienstleistungsart/' + dl.id, dl);
    }

    public deleteDienstleistungsart(dl: DienstleistungsArt): Observable<any> {
        return this.http.delete<DienstleistungsArt>(environment.API_URL + '/admin/dienstleistungsart/' + dl.id);
    }

    public getAlleDienstleistungsartenNamen(query?: string): Observable<string[]> {
        return this.listDienstleistungsarten()
            .pipe(
                map((dl: DienstleistungsArt[]) => {
                    const list: string[] = [];
                    dl.map(function (item) {
                        if (!query || item.title?.toLowerCase().indexOf(query.toLowerCase()) > -1) {
                            list.push(item.title);
                        }
                    });
                    return list;
                }),
            );
    }
}
